module.exports = __webpack_public_path__ + "static/media/paleBanner_sm1.8d682ead.png";